import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import ExitMini from './icons/ExitMini'

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload =  () => {
      resolve( reader.result )
    };
    reader.onerror =  (error) => {
      console.log('Error: ', error);
      resolve(false)
    };
  });
}

export default function MyDropzone(props) {
  const onDrop = useCallback(acceptedFiles => {

    if(acceptedFiles.length > 0){
      getBase64(acceptedFiles[0]).then((base64)=>{
          props.onDrop({base64:base64,file:acceptedFiles})
      });
    }else{
      props.onDrop({base64:null,file:acceptedFiles})
    }


  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
  const { closeStyle } = props 
  return (
    <div className='input-file-dropzone'>
      { 
        props.isDropSuccess 
        ? 
        <div className={`close ${closeStyle}`} onClick={() => props.onClose()}>
          <ExitMini/>
        </div>
        : <></>
      }
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {
          props.isDropSuccess?
          props.dropSuccessUI:
          props.dropUI
        }
        { /**
          isDragActive ?
            <p>Drop the files here ...</p> :
            <p>Drag 'n' drop some files here, or click to select files</p>
        **/}

      </div>
    </div>
   
  )
}
